export const TIMESHEET_STATUS_CODE = {
    CANCELLED: 'CAN',
} as const;

export const VALIDATION_MESSAGES = {
    NO_BOOKINGS: 'Please select at least one booking to generate a timesheet',
    MISSING_AGENT: 'Agent information',
    MISSING_CONSULTANT_CODE: 'Consultant code',
    MISSING_TIMESHEET_DATE: 'Timesheet date',
    MISSING_PERSONNEL_REF: 'Personnel reference',
    MISSING_CLIENT_REF: 'Client reference',
    MISSING_DIVISION: 'Division information',
    MISSING_DEPARTMENT: 'Department information',
    MISSING_DESCRIPTION: 'Description',
    MISSING_DURATION: 'Duration',
    MISSING_HOURLY_RATE: 'Hourly rate',
    MISSING_CLIENT_PAY: 'Client pay',
    MISSING_RATE_CODE: 'Rate code',
    MISSING_RATE_DESCRIPTION: 'Description',
} as const;

export const INPUT_STEPS = {
    DURATION: 0.01,
    CURRENCY: 0.01,
} as const;

